export class ModalSize {
  static readonly XL = 'xl'
  static readonly LG = 'lg'
  static readonly MD = 'md'
  static readonly SM = 'sm'
}
